export enum SadtPlaceEnum {
    Interno = 1,
    Externo = 2,
}